import React, { useState } from 'react'

import {
  StyleSheet,
  View,
  Text,
  Dimensions
} from 'react-native'

import {
  adaptive
} from '@sart/styles'

import { BillItem, Space } from '@sart/components'

import { useContent } from '@sart/content'

export default function ViewBills(props) {
  const { navigation } = props
  const content = useContent()

  const invoices = [
    {
      "invoiceId": 10,
      "invoiceReference": "INVOICE-8218219-1",
      "totalNewCharges": 0,
      "totalPreviousInvoice": 3000,
      "subTotal": 0,
      "total": 0,
      "vat": 0,
      "totalAmountDue": 2000,
      "outstandingAmountDue": 5000,
      "invoiceDate": "2022-11-30T00:00:00.000Z",
      "paymentDueDate": "2022-12-07T00:00:00.000Z",
      "lastPaymentAmount": 0,
      "currency": "USD",
      "category": "CLOSED"
    },
    {
      "invoiceId": 12,
      "invoiceReference": "INVOICE-8218219",
      "totalNewCharges": 0,
      "totalPreviousInvoice": 5000,
      "subTotal": 0,
      "total": 0,
      "vat": 0,
      "totalAmountDue": 2000,
      "outstandingAmountDue": 7000,
      "invoiceDate": "2022-12-30T00:00:00.000Z",
      "paymentDueDate": "2023-01-07T00:00:00.000Z",
      "lastPaymentAmount": 0,
      "currency": "USD",
      "category": "CLOSED"
    },
    {
      "invoiceId": 12,
      "invoiceReference": "INVOICE-8218219",
      "totalNewCharges": 0,
      "totalPreviousInvoice": 1000,
      "subTotal": 0,
      "total": 0,
      "vat": 0,
      "totalAmountDue": 2000,
      "outstandingAmountDue": 3000,
      "invoiceDate": "2023-01-30T00:00:00.000Z",
      "paymentDueDate": "2023-02-07T00:00:00.000Z",
      "lastPaymentAmount": 0,
      "currency": "USD",
      "category": "CLOSED"
    },
    {
      "invoiceId": 13,
      "invoiceReference": "INVOICE-8218219",
      "totalNewCharges": 0,
      "totalPreviousInvoice": 3000,
      "subTotal": 0,
      "total": 0,
      "vat": 0,
      "totalAmountDue": 2000,
      "outstandingAmountDue": 5000,
      "invoiceDate": "2023-02-28T00:00:00.000Z",
      "paymentDueDate": "2023-03-07T00:00:00.000Z",
      "lastPaymentAmount": 0,
      "currency": "USD",
      "category": "CLOSED"
    },
    {
      "invoiceId": 14,
      "invoiceReference": "INVOICE-8218219",
      "totalNewCharges": 0,
      "totalPreviousInvoice": 5000,
      "subTotal": 0,
      "total": 0,
      "vat": 0,
      "totalAmountDue": 3000,
      "outstandingAmountDue": 8000,
      "invoiceDate": "2023-03-30T00:00:00.000Z",
      "paymentDueDate": "2023-04-07T00:00:00.000Z",
      "lastPaymentAmount": 0,
      "currency": "USD",
      "category": "CURRENT"
    }
  ]

  function handleNavigation(invoice) {
    navigation.navigate('ViewBill', invoice)
  }

  return (
    <View style={styles.container}>

      {invoices.map(invoice => {
        console.log('invoice is: ' + JSON.stringify(invoice, null, 2));

        return(
          <View>
            <BillItem
              invoice={invoice}
              onPress={() => handleNavigation(invoice)}
							injectedContent={content}
            />
            <Space height={18} />
          </View>
        )
      })}
    </View>
  )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 25,
        ...adaptive.wrapperPadding
    }
})
